import { render, staticRenderFns } from "./VerificationPage.vue?vue&type=template&id=eda7c526&scoped=true&"
import script from "./VerificationPage.vue?vue&type=script&lang=js&"
export * from "./VerificationPage.vue?vue&type=script&lang=js&"
import style0 from "./VerificationPage.vue?vue&type=style&index=0&id=eda7c526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda7c526",
  null
  
)

export default component.exports